/* unplugin-vue-components disabled */import { render } from "./member_fxdetails.vue?vue&type=template&id=19abe4cf&scoped=true"
import script from "./member_fxdetails.vue?vue&type=script&lang=js"
export * from "./member_fxdetails.vue?vue&type=script&lang=js"

import "./member_fxdetails.vue?vue&type=style&index=0&id=19abe4cf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19abe4cf"]])

export default __exports__